export default function AIDataRD() {
  const problems = [
    '데이터는 많지만 활용 기준이 명확하지 않은 문제',
    'AI 기술 도입을 위한 전문 인력 부족',
    '연구개발 결과의 실증 및 검증 필요',
  ];

  const technologies = [
    { name: 'AI 알고리즘', icon: 'ri-brain-line' },
    { name: '데이터 분석', icon: 'ri-bar-chart-line' },
    { name: '모델링', icon: 'ri-function-line' },
    { name: '실증 검증', icon: 'ri-shield-check-line' },
  ];

  const process = [
    { step: '01', title: '과제 기획', desc: '문제 정의 및 연구 방향 수립' },
    { step: '02', title: '연구개발', desc: 'AI 모델 개발 및 데이터 분석' },
    { step: '03', title: '실증', desc: '현장 적용 및 효과 검증' },
    { step: '04', title: '결과 도출', desc: '성과 분석 및 개선 방안 제시' },
  ];

  return (
    <section className="py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-20">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#14B8A6]/10 border border-[#14B8A6]/20 mb-6">
            <span className="text-sm font-medium text-[#0D9488]">Service 01</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 leading-tight mb-6">
            AI · Data R&D
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl leading-relaxed">
            AI와 데이터 기술은<br />
            연구 단계에서 끝나서는 안 됩니다.
          </p>
          <p className="text-lg text-gray-600 max-w-3xl leading-relaxed mt-4">
            4-lab은 공공·기업 연구개발 과제를 중심으로<br />
            AI 모델 개발, 데이터 분석, 실증 사업까지<br />
            연결되는 R&D를 수행합니다.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12 mb-20">
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-6">해결하는 문제</h3>
            <ul className="space-y-4">
              {problems.map((problem, index) => (
                <li key={index} className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-3 mt-0.5 flex-shrink-0">
                    <i className="ri-error-warning-line text-sm text-[#0D9488]"></i>
                  </div>
                  <span className="text-sm text-gray-600">{problem}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-6">제공 기술</h3>
            <div className="space-y-4">
              {technologies.map((tech, index) => (
                <div key={index} className="flex items-center">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#F0FDFA] mr-3">
                    <i className={`${tech.icon} text-xl text-[#0D9488]`}></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">{tech.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-6">적용 사례</h3>
            <div className="space-y-3">
              <div className="p-4 bg-[#F0FDFA] rounded-lg border border-[#99F6E4]/30">
                <p className="text-sm text-gray-700">공공 데이터 AI 분석 시스템</p>
              </div>
              <div className="p-4 bg-[#F0FDFA] rounded-lg border border-[#99F6E4]/30">
                <p className="text-sm text-gray-700">제조 품질 예측 AI 모델</p>
              </div>
              <div className="p-4 bg-[#F0FDFA] rounded-lg border border-[#99F6E4]/30">
                <p className="text-sm text-gray-700">문서 자동 분류 시스템</p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-2xl font-bold text-gray-900 mb-10 text-center">수행 방식</h3>
          <div className="grid md:grid-cols-4 gap-6">
            {process.map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#14B8A6] text-white text-xl font-bold mx-auto mb-4">
                  {item.step}
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h4>
                <p className="text-sm text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
